import React, { useState, useEffect, useContext } from "react";
import { ContextEngine } from "../engine/ContextEngine";

const FilterMenu = ({ unitId, colName, options, position }) => {
  const { context, updateContext } = useContext(ContextEngine);

  // 1. Correctly locate the specific table unit view
  const tableUnit = context.context_units?.find(u => u.id === unitId);
  const currentFilters = tableUnit?.view?.filters || {};

  // 2. Initialize local state based on existing filter string ("val1|val2")
  const [selected, setSelected] = useState([]);
  const normalizedOptions = options.map(String);

  const handleApply = () => {
    const filterString = selected.length === normalizedOptions.length ? "" : selected.join("|");

    // 1. Find the numerical index of this unit in the array
    const unitIndex = context.context_units.findIndex(u => u.id === unitId);

    if (unitIndex !== -1) {
      // 2. Use the INDEX in the path instead of the ID
      const path = `context_units.${unitIndex}.view.filters.${colName}`;

      console.log("DEBUG: Resolved Path ->", path); // Should look like context_units.0...
      updateContext(path, filterString);
    } else {
      console.error("Unit not found for ID:", unitId);
    }

    updateContext("view.modal", null);
  };

  const handleClearFilter = () => {
    // 1. Find the index first!
    // const unitIndex = context.context_units?.findIndex(u => u.id === unitId);

    // if (unitIndex !== -1 && unitIndex !== undefined) {
    //   // 2. Use the index in the path
    //   updateContext(`context_units.${unitIndex}.view.filters.${colName}`, "");
    // }

    updateContext("view.modal", null);
  };

  const isAllSelected = normalizedOptions.length > 0 && selected.length === normalizedOptions.length;

  useEffect(() => {
    const rawValue = tableUnit?.view?.filters?.[colName]; // Access directly here
    if (rawValue) {
      setSelected(String(rawValue).split("|").map(String));
    } else {
      setSelected(options.map(String));
    }
    // Debug log to see if the modal is actually seeing the data
    console.log(`Modal for ${colName} initialized with:`, rawValue);
  }, [colName, unitId, tableUnit?.view?.filters]); // Add the specific filter path

  return (
    <div
      className="filter-menu"
      style={{
        position: "fixed",
        top: position.y,
        left: position.x,
        width: "220px",
        background: "rgba(30, 30, 30, 0.9)", // Dark background with opacity
        border: "1px solid #444", // Dark border
        borderRadius: "8px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
        padding: "8px",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        animation: "fadeIn 0.15s ease-in-out",
      }}
    >
      {/* Select / Unselect All */}
      <div style={{ marginBottom: "6px", fontWeight: "bold", color: "#fff" }}>
        <label style={{ cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={() => isAllSelected ? setSelected([]) : setSelected([...normalizedOptions])}
            style={{ accentColor: "#4CAF50" }} // Green checkbox accent
          />{" "}
          {isAllSelected ? "Unselect All" : "Select All"}
        </label>
      </div>

      {/* Options List */}
      <div style={{ maxHeight: "200px", overflowY: "auto", marginBottom: "8px", borderTop: "1px solid #444" }}>
        {normalizedOptions
          .slice()
          .sort((a, b) => !isNaN(a) && !isNaN(b) ? Number(a) - Number(b) : a.localeCompare(b))
          .map((val, i) => {
            const isSelected = selected.includes(val);
            return (
              <div key={i} style={{ backgroundColor: isSelected ? "#333" : "#222", padding: "4px" }}>
                <label style={{ display: "flex", alignItems: "center", cursor: "pointer", width: "100%" }}>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => setSelected(isSelected ? selected.filter(v => v !== val) : [...selected, val])}
                    style={{ accentColor: "#4CAF50" }} // Green checkbox accent
                  />
                  <span style={{ marginLeft: "6px", color: isSelected ? "#4CAF50" : "#ddd" }}>{val}</span>
                </label>
              </div>
            );
          })}
      </div>

      {/* Buttons */}
      <div style={{ display: "flex", gap: "6px", justifyContent: "flex-end" }}>
        <button
          style={{
            backgroundColor: "#4CAF50",
            color: "#fff",
            border: "none",
            padding: "6px 12px",
            borderRadius: "4px",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)"
          }}
          onClick={handleApply}
        >
          Apply
        </button>
        <button
          style={{
            backgroundColor: "#f44336",
            color: "#fff",
            border: "none",
            padding: "6px 12px",
            borderRadius: "4px",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)"
          }}
          onClick={handleClearFilter}
        >
          Clear
        </button>
      </div>

      <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
};

export default FilterMenu;
